import React, { useState } from "react";
import AccountMasterCard from "../../Components/Card/AccountMasterCards/AccountMasterCard";
import { Divider,Box,Paper,Stack } from "@mui/material";
import { useSelector } from "react-redux";
import AccountMasterTable from "../../Components/Table/AccountMaster/AccountMasterTable";
import { SessionVerificationAdmin } from "../../Components/SessionManagement/SessionManagementAdmin";
import Header2 from "../../Components/header/Header2/Header2";
import MiniDrawer from "../../Components/sidebar/SideBar2";

//FUNCTION
const AccountMaster = () => {
  //#region code
  const open = useSelector((state) => state.sideExpand.open);
  const [editData, setEditData] = useState({});
  const [isChanged, setIsChanged] = useState(false);

  const handleEdit = (data) => {
    setEditData(data[0]);
  };

  //#endregion

  return (
    <>
      <SessionVerificationAdmin />
      <Header2 />
      <MiniDrawer />

      <Box
        sx={{
          marginLeft: {
            xs: 7,
            sm: 8,
          },
          ...(open && { marginLeft: 33 }),
          transition: "200ms",
          minHeight: "77vh",
        }}
      >
        <Stack direction="column" justifyContent="center" alignItems="center">
          <Paper
            sx={{
              width: "95%",
              //marginLeft: 2,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              //paddingLeft: 3,
              pb: 5,
            }}
            elevation={0}
          >
            <AccountMasterCard
              editData={editData}
              setEditData={setEditData}
              isChanged={isChanged}
              setIsChanged={setIsChanged}
            />

            <Divider />
            <AccountMasterTable
              handleEditData={handleEdit}
              isChanged={isChanged}
            />
          </Paper>
        </Stack>
      </Box>
    </>
  );
};
export default AccountMaster;
